import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './resources/textbook-empty-v2.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c0a0dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-list-empty-placeholder" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home-list-empty-placeholder__img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "home-list-empty-placeholder__text" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "text", {}, undefined, true)
    ])
  ]))
}